import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarService } from './snackbar.service';
import { Router } from '@angular/router';
import { CustomToastComponent } from '../../shared/component/custom-toast/custom-toast.component';
import { TokenService } from '../../shared/service/token.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class HttpErrorsService {
  mailText: string = '';
  Uservalue: any;
  user: any;
  constructor(
    private snackbarService: SnackbarService,
    private router: Router,
    public snackBar: MatSnackBar,
    public tokenService: TokenService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  public handleHttpError(error: any) {
    if (error?.status >= 399) {
      const status = error?.status;
      const message = error?.error?.detail;
      const duration = status >= 500 ? 0 : 5000; // No auto-close for >=500 errors
      this.handleGenericErrors(error, status, message, duration);
    }
  }

  private handleGenericErrors(
    errorResponse: any,
    errorTitle: any,
    error: any,
    duration: number
  ) {
    let snackbarUrl: string | undefined;

    if (isPlatformBrowser(this.platformId)) {
      snackbarUrl = window?.location?.href;
    }

    const userData: any = this.tokenService.getUserInfo();
    this.Uservalue = JSON.parse(userData);
    this.user = this.Uservalue?.user || '';

    const snackbarOptions: any = {
      data: {
        message: error,
        icon: 'close',
        action: 'close',
        color: 'red',
        traceId: errorResponse?.error?.traceId ?? '',
        user: this.user,
        url: snackbarUrl,
      },
      panelClass: 'snackbar',
    };

    // Only set duration for <500 errors
    if (duration > 0) {
      snackbarOptions['duration'] = duration;
    }

    // Open snackbar
    this.snackbarService.openFromComponent(CustomToastComponent, snackbarOptions);

    // Only auto-resolve if there’s a timer
    const promise = duration > 0
      ? new Promise<void>((resolve) => setTimeout(() => resolve(), duration))
      : Promise.resolve();

    return promise.then(() => this.handleErrorAction(errorResponse, errorTitle));
  }

  public handleErrorAction(errorResponse: any, errorTitle: any) {
    if (errorTitle == 401 || errorTitle == 403) {
      this.tokenService.removeLogin();
      if(this.router.url === '/'){
        //do not refresh the page
      }
      else{
      this.router.navigateByUrl('/');
      }
      // write here to logout from application
    }
  }
}
